import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const FilterByChannelOrgCode = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByChannelOrgCode }
  } = localizedStrings;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await request.get('/channelOrgCode');
      if (result) {
        const transformedResult = _.get(result, 'data.data', []).map(
          orgCode => ({
            label: orgCode,
            value: orgCode
          })
        );
        setOptions(transformedResult);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, channelOrgCode: value });
        }}
        label={filterByChannelOrgCode}
        options={options}
        value={filters.channelOrgCode}
      />
    </div>
  );
};

FilterByChannelOrgCode.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByChannelOrgCode;
